<template>
  <v-dialog v-model="getLoading" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        <span>&nbsp;</span>
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Loading",
  computed: {
    ...mapGetters({
      'getLoading': 'settings/getLoading',
    }),
  },
}
</script>

<style scoped>

</style>